import React, { useState } from "react";
import { motion } from "framer-motion";
import KategoriDrink from "../../KategoriDrink";
import List from "../../list_categori";

const drinks = [
  "Es Teh Manis",
  "Kopi Susu",
  "Ice Blended Coklat",
  "Jus Alpukat",
  "Thai Tea",
  "Lemon Tea",
  "Es Teh Manis",
  "Kopi Susu",
  "Ice Blended Coklat",
  "Jus Alpukat",
  "Thai Tea",
  "Lemon Tea",
];

const foods = [
  "Nasi Goreng",
  "Mie Ayam",
  "Sate Ayam",
  "Bakso",
  "Ayam Geprek",
  "Soto Ayam",
  "Nasi Goreng",
  "Mie Ayam",
  "Sate Ayam",
  "Bakso",
  "Ayam Geprek",
  "Soto Ayam",
];

export default function MenuPage() {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <KategoriDrink />
      <List />
      <div className="min-h-screen bg-white text-black py-10 px-4 flex items-center justify-center text-modifikasi">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl w-full">

          {/* KIRI - DRINK */}
          <motion.div
            className="bg-white rounded-2xl p-2"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: false, amount: 0.3 }}
            transition={{ duration: 0.8 }}
          >
            <motion.img
              onClick={() => setShowModal(true)}
              src="http://4.bp.blogspot.com/-zvsDpziZgNg/VeYMlPQCF4I/AAAAAAAABfY/CP9DUpOQBPw/s1600/Buku_Daftar_Menu_Nasi_Timbel_3.png"
              alt="Drink Banner"
              className="w-full h-98 object-cover rounded-xl mb-10 cursor-pointer hover:scale-105 transition-transform duration-300"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: false }}
            />

            <motion.h2
              className="text-3xl font-bold text-left mb-10 uppercase"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2, duration: 0.6 }}
              viewport={{ once: false }}
            >
              Daftar <span className="text-pink-700">Menu Drink</span>
            </motion.h2>

            <motion.ul
              className="space-y-2"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false }}
              variants={{
                hidden: { opacity: 0 },
                visible: {
                  opacity: 1,
                  transition: { staggerChildren: 0.05 },
                },
              }}
            >
              {drinks.map((drink, index) => (
                <motion.li
                  key={index}
                  className="font-semibold pb-1"
                  variants={{ hidden: { opacity: 0, x: -20 }, visible: { opacity: 1, x: 0 } }}
                >
                  {drink}
                </motion.li>
              ))}
            </motion.ul>
          </motion.div>

          {/* KANAN - FOOD */}
          <motion.div
            className="bg-white rounded-2xl p-2"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: false, amount: 0.3 }}
            transition={{ duration: 0.8 }}
          >
            <motion.h2
              className="text-3xl font-bold text-left mb-10 uppercase"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2, duration: 0.6 }}
              viewport={{ once: false }}
            >
              Daftar <span className="text-pink-700">Menu Food</span>
            </motion.h2>

            <motion.ul
              className="space-y-2"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false }}
              variants={{
                hidden: { opacity: 0 },
                visible: {
                  opacity: 1,
                  transition: { staggerChildren: 0.05 },
                },
              }}
            >
              {foods.map((food, index) => (
                <motion.li
                  key={index}
                  className="font-semibold pb-1"
                  variants={{ hidden: { opacity: 0, x: -20 }, visible: { opacity: 1, x: 0 } }}
                >
                  {food}
                </motion.li>
              ))}
            </motion.ul>
          </motion.div>
        </div>
      </div>

      {/* MODAL UNTUK ZOOM GAMBAR */}
      {showModal && (
        <motion.div
          className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50"
          onClick={() => setShowModal(false)}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.div
            className="relative w-full max-w-[90vw] md:max-w-2xl p-4 sm:p-6"
            onClick={(e) => e.stopPropagation()}
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.8, opacity: 0 }}
            transition={{ duration: 0.3 }}
          >
            <button
              className="absolute top-2 right-2 text-pink-700 hover:text-white text-3xl font-bold z-10"
              onClick={() => setShowModal(false)}
            >
              &times;
            </button>
            <img
              src="http://4.bp.blogspot.com/-zvsDpziZgNg/VeYMlPQCF4I/AAAAAAAABfY/CP9DUpOQBPw/s1600/Buku_Daftar_Menu_Nasi_Timbel_3.png"
              alt="Zoomed"
              className="w-full max-h-[80vh] object-contain rounded-xl shadow-lg"
            />
          </motion.div>
        </motion.div>
      )}
    </>
  );
}
